<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" data-testid="directions-40" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Edit Job</h1>
                    <div class="title">
                    </div>

                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
                </div>
            </div>
            <el-form class="full_page" :model="form" ref="userForm" label-position="top">
                <div class="job_row">
                    <div class="job_row--content">
                        <el-form-item class="no-scroll" :required="true" label="Job Type" prop="job_type">
                            <el-select data-testid="directions-42" v-model="form.job_type" size="large"
                                placeholder="Select Job Type" popper-class="normal-select">
                                <el-option v-for="option in jobTypeOptions" :key="option.value" :label="option.label"
                                    :value="option.value" />
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="job_row">
                    <div class="job_row--content">
                        <el-form-item class="no-scroll" :required="true" label="Role Type " prop="platform_role_id">
                            <el-select data-testid="directions-42" v-model="form.platform_role_id" size="large"
                                placeholder="Select Role Type" popper-class="normal-select">
                                <el-option v-for="option in filteredPlatformRoles" :key="option.value"
                                    :label="option.label" :value="option.value" />
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <el-form-item :error="v$.job_title.$error" :show-message="false" class="no-scroll" :required="true"
                    label="Job Title" prop="job_title">
                    <el-input data-testid="directions-43" class="job_row--content" v-model="form.job_title"
                        placeholder="Please enter job title" @blur="validateField('job_title')"
                        @input="validateField('job_title')"></el-input>
                    <el-form-item-error v-if="v$.job_title.$error">{{ v$.job_title.$errors[0].$message
                        }}</el-form-item-error>
                </el-form-item>
                <div class="job_row">
                    <el-form-item label="Set Job Location" :error="v$.job_location.$error" :show-message="false"
                        class="no-scroll" prop="job_location" :required="true">
                        <div class="el-input el-input--prefix">
                            <vue-google-suburb-autocomplete data-testid="directions-102" id="map"
                                classname="el-input__inner" v-model="form.job_location"
                                :initial-location="jobLocationText" placeholder="Find your address"
                                v-on:placechanged="updateAddressData" @keyup="setAddress" :key="addressComponent"
                                :country="countryArray" />
                            <span class="el-input__prefix"><i class="el-input__icon el-icon-search"></i></span>
                        </div>
                        <el-form-item-error v-if="v$.job_location.$error">{{ v$.job_location.$errors[0].$message
                            }}</el-form-item-error>
                    </el-form-item>
                </div>
                <div class="job_row">
                    <el-form-item class="no-scroll">
                        <el-checkbox v-model="form.hide_salary">Hide Salary</el-checkbox>
                    </el-form-item>
                </div>
                <div class="job-rate">
                    <el-form-item class="no-scroll" :required="true" label="Rate" prop="rate_type">
                        <el-select data-testid="directions-rate-type" v-model="form.rate_type" size="large"
                            placeholder="Select Rate Type" popper-class="normal-select">
                            <el-option label="Hourly" value="hourly">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M10 1.66667C14.6025 1.66667 18.3333 5.39751 18.3333 10C18.3333 14.6025 14.6025 18.3333 10 18.3333C5.39751 18.3333 1.66667 14.6025 1.66667 10C1.66667 5.39751 5.39751 1.66667 10 1.66667ZM10 3.33334C8.23189 3.33334 6.5362 4.03572 5.28596 5.28596C4.03572 6.5362 3.33334 8.23189 3.33334 10C3.33334 11.7681 4.03572 13.4638 5.28596 14.7141C6.5362 15.9643 8.23189 16.6667 10 16.6667C11.7681 16.6667 13.4638 15.9643 14.7141 14.7141C15.9643 13.4638 16.6667 11.7681 16.6667 10C16.6667 8.23189 15.9643 6.5362 14.7141 5.28596C13.4638 4.03572 11.7681 3.33334 10 3.33334ZM10 5.00001C10.2041 5.00003 10.4011 5.07497 10.5536 5.2106C10.7062 5.34623 10.8036 5.53313 10.8275 5.73584L10.8333 5.83334V9.65501L13.0892 11.9108C13.2386 12.0608 13.3254 12.262 13.3319 12.4737C13.3383 12.6853 13.264 12.8914 13.124 13.0502C12.9839 13.209 12.7887 13.3086 12.5779 13.3287C12.3672 13.3487 12.1567 13.2878 11.9892 13.1583L11.9108 13.0892L9.41084 10.5892C9.28132 10.4595 9.19814 10.2908 9.17417 10.1092L9.16667 10V5.83334C9.16667 5.61232 9.25447 5.40036 9.41075 5.24408C9.56703 5.0878 9.77899 5.00001 10 5.00001Z"
                                        fill="currentColor" />
                                </svg>
                                Hourly
                            </el-option>
                            <el-option label="Annual" value="annual">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M10 3.125L9.80437 3.3L2.675 10.5081L2.24625 10.9381L2.67562 11.3881L8.61312 17.3256L9.06312 17.755L9.49437 17.3256L16.7006 10.1962L16.875 10V3.125H10ZM10.5275 4.375H15.625V9.4725L9.0625 15.9962L4.00375 10.9375L10.5275 4.375ZM13.75 5.625C13.5842 5.625 13.4253 5.69085 13.3081 5.80806C13.1908 5.92527 13.125 6.08424 13.125 6.25C13.125 6.41576 13.1908 6.57473 13.3081 6.69194C13.4253 6.80915 13.5842 6.875 13.75 6.875C13.9158 6.875 14.0747 6.80915 14.1919 6.69194C14.3091 6.57473 14.375 6.41576 14.375 6.25C14.375 6.08424 14.3091 5.92527 14.1919 5.80806C14.0747 5.69085 13.9158 5.625 13.75 5.625Z"
                                        fill="currentColor" />
                                </svg>
                                Annual
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <div class="inner-label">
                        {{ form.rate_type === 'hourly' ? 'Hourly' : 'Annual' }} Payment Range
                        <span class="sub-label" v-if="isAustralia">(Excluding-super)</span>
                    </div>
                    <el-form-item :error="v$.min_rate.$error" :show-message="false" class="no-scroll" label="Min rate"
                        :required="true" prop="min_rate">
                        <div class="input-wrapper">
                            <span class="el-input__prefix">
                                $
                            </span>
                            <el-input data-testid="directions-53" v-model="form.min_rate" placeholder="0.00"
                                @input="validateField('min_rate')" class="dollar-input">
                                <template #suffix v-if="isAustralia">
                                    AUD
                                </template>
                                <template #suffix v-else>
                                    USD
                                </template>
                            </el-input>
                        </div>
                        <el-form-item-error v-if="v$.min_rate.$error">
                            {{ v$.min_rate.$errors[0].$message }}
                        </el-form-item-error>
                    </el-form-item>
                    <el-form-item :error="v$.max_rate.$error" :show-message="false" class="no-scroll" label="Max rate"
                        :required="true" prop="max_rate">
                        <div class="input-wrapper">
                            <span class="el-input__prefix">
                                $
                            </span>
                            <el-input data-testid="directions-54" v-model="form.max_rate" placeholder="0.00"
                                @input="validateField('max_rate')" class="dollar-input">
                                <template #suffix v-if="isAustralia">
                                    AUD
                                </template>
                                <template #suffix v-else>
                                    USD
                                </template>
                            </el-input>
                        </div>
                        <el-form-item-error v-if="v$.max_rate.$error">{{ v$.max_rate.$errors[0].$message
                            }}</el-form-item-error>
                    </el-form-item>
                    <el-form-item :required="true" label="Are you willing to give bonus?">
                        <el-radio-group class="" v-model="form.bonus">
                            <el-radio label="Yes" size="large">Yes</el-radio>
                            <el-radio label="No" size="large">No</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
                <div class="job_row">
                    <el-form-item :error="v$.job_category.$error" :show-message="false" class="no-scroll"
                        :required="true" label="Job Category" prop="job_category">
                        <el-radio-group data-testid="directions-45" class="job-category-select"
                            v-model="form.job_category" @change="validateField('job_category')">
                            <el-radio v-for="option in selectedCategories" :key="option.value" :label="option.value">{{
                                option.label }}</el-radio>
                        </el-radio-group>
                        <el-form-item-error v-if="v$.job_category.$error">{{ v$.job_category.$errors[0].$message
                            }}</el-form-item-error>
                    </el-form-item>
                    <button class="categories-toggle" type="primary" @click="showDialog($event)">See all
                        categories</button>
                </div>
                <div v-if="selectedCombineSkillOptions.length > 0" class="selected-skills">
                    <h2>Selected Skills</h2>
                    <ul>
                        <li v-for="option in selectedCombineSkillOptions" :key="option"
                            @click="removeSelectedSkill(option)">
                            {{ option.label }}
                            <i class="el-tag__close el-icon-close"></i>
                        </li>
                    </ul>
                </div>
                <div class="job_row">
                    <div class="input_label">Popular Skills</div>
                    <div class="job_row--content">
                        <el-checkbox-group data-testid="directions-47" class="skill-checkbox-select"
                            v-model="selectedPopularSkills">
                            <el-checkbox v-for="item in popularSkillsOptions" :disabled="isSelected(item)"
                                :key="item.value" :label="item">
                                {{ item.label }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="input_label editor-label">Description</div>
                <div class="describe-need">
                    <el-form-item :error="v$.job_description.$error" :show-message="false" class="no-scroll"
                        :required="true" prop="job_description">
                        <div class="OneLinkNoTx">
                            <QuillEditor style="min-height: 300px" v-model:content="form.job_description"
                                contentType="html" @blur="validateField('job_description')"
                                @editorChange="validateField('job_description')"
                                @input="validateField('job_description')" theme="snow" :toolbar="[
                                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                    [{ 'color': [] }],
                                    [{ 'align': [] }],
                                    ['bold', 'italic', 'underline'],
                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                    ['link', 'image', 'video'],
                                ]" />
                        </div>
                        <el-form-item-error v-if="v$.job_description.$error">{{ v$.job_description.$errors[0].$message
                            }}</el-form-item-error>
                    </el-form-item>
                    <el-button class="submit" type="primary" @click="generateContentAi">
                        <template v-if="form.job_description">Generate new Job Description</template>
                        <template v-else>Generate description using AI</template>
                    </el-button>
                    <div>
                        <el-form-item :required="true"
                            label="Do you have any questions that you want to ask the applicants?">
                            <el-radio-group class="" v-model="form.questionary" @change="checkQuestionary">
                                <el-radio label="Yes" size="large">Yes</el-radio>
                                <el-radio label="No" size="large">No</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <div v-if="form.questionary === 'Yes'">
                            <div class="required-label">Questions</div>

                            <el-form-item-error v-if="v$.questions.$error">{{ v$.questions.$errors[0].$validator ===
                                "required" ?
                                v$.questions.$errors[0].$message : '' }}
                            </el-form-item-error>

                            <div v-for="(item, index) in form.questions" :key="index" class="question-row">
                                <el-form-item class="question-label"
                                    :error="v$.questions.$each.$message[index].length > 0 && item.type == ''"
                                    :show-message="false">
                                    <el-select v-model="item.type" placeholder="Select question type"
                                        class="question-type-select">
                                        <el-option label="Paragraph" value="text"> <i
                                                class="el-icon-edit"></i>Paragraph</el-option>
                                        <el-option label="Checkboxes" value="checkbox"><i
                                                class="el-icon-check"></i>Checkboxes</el-option>
                                        <el-option label="Multiple choice" value="radio"><i
                                                class="el-icon-circle-check"></i>Multiple
                                            choice</el-option>
                                        <el-option label="Dropdown" value="select"><i
                                                class="el-icon-arrow-down"></i>Dropdown</el-option>
                                        <el-option label="File upload" value="file"><i class="el-icon-upload"></i>File
                                            upload</el-option>
                                    </el-select>

                                    <el-form-item-error
                                        v-if="v$.questions.$each.$message[index].length > 0 && item.type == ''">{{
                                            v$.questions.$errors[0].$message[index][0]
                                        }}
                                    </el-form-item-error>

                                    <el-form-item class="question-label" v-if="item.type === 'text'"
                                        :error="item.type === 'text' && v$.questions.$each.$response.$data[index].question.$error"
                                        :show-message="false">
                                        <el-input type="textarea" v-if="item.type === 'text'" v-model="item.question"
                                            @input="handleQuestionChange(index, $event.target.value)"
                                            :placeholder="`Question ${index + 1}`">
                                        </el-input>
                                    </el-form-item>

                                    <el-form-item-error
                                        v-if="item.type === 'text' && v$.questions.$each.$response.$data[index].question.$error">{{
                                            v$.questions.$each.$response.$errors[index].question[0].$message
                                        }}
                                    </el-form-item-error>

                                    <div
                                        v-if="item.type === 'checkbox' || item.type === 'radio' || item.type === 'select'">

                                        <el-form-item class="question-label"
                                            :error="v$.questions.$errors[0]?.$message[index][0] && item.options.length === 0"
                                            :show-message="false">
                                            <el-input type="textarea" v-model="item.question"
                                                @input="handleQuestionChange(index, $event.target.value)"
                                                :placeholder="`Question ${index + 1}`">
                                            </el-input>
                                        </el-form-item>

                                        <el-form-item-error
                                            v-if="v$.questions.$errors[0]?.$message[index][0] && item.options.length === 0">{{
                                                v$.questions.$errors[0]?.$message[index][0]
                                            }}
                                        </el-form-item-error>


                                        <div v-for="(option, optionIndex) in item.options" :key="optionIndex"
                                            class="question-option">

                                            <el-form-item class="question-label"
                                                :error="v$.questions.$each.$response.$errors[index].options?.length > 0 && (v$.questions.$each.$response.$errors[index].options[0]?.$model[optionIndex] == '')"
                                                :show-message="false">
                                                <el-input type="textarea" v-model="item.options[optionIndex]"
                                                    :placeholder="`Option ${optionIndex + 1}`">
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item-error class="ml-3"
                                                v-if="v$.questions.$each.$response.$errors[index].options?.length > 0 && (v$.questions.$each.$response.$errors[index].options[0]?.$model[optionIndex] == '')">{{
                                                    v$.questions.$each.$response.$errors[index].options[0].$message
                                                }}
                                            </el-form-item-error>

                                            <el-button type="danger" icon="el-icon-close" class="remove-option"
                                                @click="removeOption(index, optionIndex)">
                                            </el-button>
                                        </div>

                                        <el-button type="link" class="add-option d-block ml-3" size="small"
                                            @click="addOption(index)"><i class="el-icon-plus"></i>Add Option</el-button>
                                    </div>

                                    <div v-if="item.type === 'file'">
                                        <el-form-item class="question-label"
                                            :error="v$.questions.$each.$response.$data[index].question.$error"
                                            :show-message="false">
                                            <el-input type="textarea" v-model="item.question"
                                                @input="handleQuestionChange(index, $event.target.value)"
                                                :placeholder="`Question ${index + 1}`">
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item-error
                                            v-if="v$.questions.$each.$response.$data[index].question.$error">{{
                                                v$.questions.$each.$response.$errors[index].question[0].$message
                                            }}</el-form-item-error>
                                    </div>
                                    <div class="question-footer d-flex justify-content-end">
                                        <el-button type="danger" icon="el-icon-delete" class="remove-question"
                                            @click="removeQuestion(index)">Remove Question</el-button>
                                    </div>
                                </el-form-item>
                            </div>
                            <div>
                                <el-button type="primary" class="add-question mt-2" @click="addQuestion">
                                    <i class="el-icon-plus"></i>Add Question
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="subscription">
                    <div class="usage-notification available" v-if="freeJobPosts !== 0 && !isLocumateAndSpecialRole && jobPostStatus === 'draft'">
                        <!-- <p>
                            You have <strong>{{ freeJobPosts }}</strong> free job ads remaining within your subscription.
                        </p> -->
                        <SubscriptionBar
                            :remainingSubscriptions="freeJobPosts"
                            :totalSubscriptions="totalNumberOfFreeJobListings"
                            text="Free job ads remaining"
                        />
                    </div>
                    <div class="usage-notification unavailable" v-if="freeJobPosts === 0 && !isLocumateAndSpecialRole && jobPostStatus === 'draft'">
                        <p v-if="usedFreeJobListings === 0">
                            You have used all your available free jobs ads. you will be charged
                        </p>
                        <p>
                            Job Ad Fee of
                            <strong>{{ Amount(justJobPostingPrice) }}</strong> <span v-if="isAus">(Excluding GST)</span>
                            for this job post will be charged in the next invoice.
                        </p>
                        <div v-html="discountAndTaxInfosHtml"></div>
                    </div>
                </div>
                <div class="coupon-code mb-3" v-if="jobPostStatus === 'draft' && freeJobPosts === 0 && !isLocumateAndSpecialRole">
                    <CouponCodeComponent
                    @updateDiscount="updateJobPostingPrice"
                    @clearCouponCode="clearCouponCode"
                    />
                </div>
                

                <template v-if="jobPostStatus === 'draft'">
                    <div class="button-group">
                        <el-button class="submit" v-if="jobPostStatus == 'draft'" :disabled="isSubmitDisabled"
                            data-testid="directions-55" type="primary" @click="updateJobPost('draft')">
                            Update draft
                        </el-button>
                        <el-button v-if="freeJobPosts === 0 && !isLocumateAndSpecialRole" class="submit" type="primary" data-testid="directions-56"
                            :disabled="isSubmitDisabled" @click="payToPublish()">
                            Publish
                        </el-button>
                        <el-button v-else class="submit" type="primary" data-testid="directions-56"
                            :disabled="isSubmitDisabled" @click="updateJobPost('publish')">
                            Publish
                        </el-button>
                    </div>
                </template>
                <template v-else>
                    <div class="button-group">
                        <el-button class="submit" type="primary" data-testid="directions-56"
                            :disabled="isSubmitDisabled" @click="updateJobPost('publish')">Save
                        </el-button>
                    </div>
                </template>
            </el-form>

            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
            </div>

        </div>
        <el-drawer v-model="dialogVisible" custom-class="bottom_drop_up" :append-to-body="true" :destroy-on-close="true"
            title="Job Categories" direction="btt">
            <el-radio-group data-testid="directions-48" v-model="form.job_category" @change="handleSelectionChange"
                class="job-category-select">
                <el-radio v-for="option in getCategories" :key="option.value" :label="option.value">{{ option.label
                    }}</el-radio>
            </el-radio-group>
            <el-button type="primary" @click="selectCategory(option)">Confirm</el-button>
        </el-drawer>
    </div>
</template>


<script>
import { reactive, computed, inject, onMounted, ref, onBeforeMount, watch } from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useRouter, useRoute
} from 'vue-router'
import { useVuelidate } from '@vuelidate/core';
import { required, helpers, maxLength } from '@vuelidate/validators';
import { useStore } from "vuex";
import { ElMessageBox, ElMessage } from "@/components/Vendor/Element";
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { VueGoogleSuburbAutocomplete } from "@/components/components";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import CouponCodeComponent from '../Components/CouponCodeComponent.vue';
import SvgIcon from '@/components/Svg/SvgIcon.vue';
import SubscriptionBar from '@/components/Subscription/SubscriptionBar.vue';

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        QuillEditor,
        VueGoogleSuburbAutocomplete,
        CouponCodeComponent,
        SvgIcon,
        SubscriptionBar
    },
    directives: {

    },

    setup() {
        const $router = useRouter()
        const setPageClassGlobal = inject(['setPageClassGlobal']);
        const $store = useStore();
        const $route = useRoute();
        const jobId = computed(() => $route.params.jobId);
        const brandName = process.env.VUE_APP_BRAND;
        const isAustralia = isAustraliaRegion();
        const platformRoleId = ref(null);
        const countryArray = computed(() => {
            const region = process.env.VUE_APP_REGION;
            if (region === 'US') return ['us'];
            if (region === 'AU') return ['au'];
            return []; // Default or empty if region is not recognized
        });
        const userData = $store.getters.GET_USER_DATA;
        const freeJobPosts =
        userData.jobListingSubscriptionDetails.remainingFreeJobListings;
        const addressComponent = ref(0);
        const jobLocationText = ref('');

        const selectedCombineSkillOptions = computed(() => {
            return [...searchSkillOptions.value, ...selectedPopularSkills.value];
        });

        const form = reactive({
            job_type: null,
            job_title: '',
            job_location: '',
            job_category: '',
            job_skills: [],
            min_rate: null,
            max_rate: null,
            rate_type: 'hourly', // Added rateType property
            bonus: 'No',
            job_description: null,
            short_description: null,
            save_as: null,
            questionary: null,
            questions: [],
            platform_role_id: null
        });

        const searchSkillOptions = ref([]);
        const searchQueryoptions = ref([]);
        const loading = ref(false);

        const selectedPopularSkills = ref([]);
        let popularSkillsOptions = ref([]);

        const jobTypeOptions = ref([]);
        const jobLocations = ref([])

        let getCategories = ref([]);

        let selectedCategories = ref([]);
        const selectedOption = ref(null);
        const dialogVisible = ref(false);
        const usedFreeJobListings =
            userData.jobListingSubscriptionDetails.usedFreeJobListings;
        const subscription = ref(
        userData.calculatedSubscriptions &&
            userData.calculatedSubscriptions.subscription
            ? userData.calculatedSubscriptions.subscription
            : 0
        );
        const totalNumberOfFreeJobListings = userData.jobListingSubscriptionDetails.totalNumberOfFreeJobListings;
        const jobPostingPrice = ref(0);
        const isAus = isAustraliaRegion();
        const originalJobPostingPrice = ref(0);
        const justJobPostingPrice = ref(0);
        const discountAndTaxInfosHtml = ref("");
        const getJobPostPriceInfos = $store.dispatch("GET_JOB_POST_PRICE_INFOS");
        const jobPostStatus = ref('');
        getJobPostPriceInfos
            .then((data) => {
                jobPostingPrice.value = data.jobPostingPrice;
                originalJobPostingPrice.value = data.jobPostingPrice;
                justJobPostingPrice.value = data.justJobPostingPrice;
                discountAndTaxInfosHtml.value = data.jobpostDiscountAndTaxInfoHtml;
            })
            .catch((error) => {
                console.error("Error fetching job post price info:", error);
            });

        const Amount = (amount) => {
            return Intl.NumberFormat("en-AU", {
                style: "currency",
                currency: "AUD",
            }).format(amount);
        };

        const updateJobPostingPrice = (response) => {
      jobPostingPrice.value = response.newJobPostingPrice;
      discountAndTaxInfosHtml.value = response.discountAndTaxInfosHtml;
      // if (discountInfo.type === "percent") {
      //   jobPostingPrice.value =
      //     jobPostingPrice.value -
      //     (discountInfo.percent / 100) * jobPostingPrice.value;
      // }

      // if (discountInfo.type === "amount") {
      //   jobPostingPrice.value =
      //     jobPostingPrice.value - discountInfo.converted_amount;
      // }
    };

    const clearCouponCode = (isCleared) => {
      if (isCleared) {
        jobPostingPrice.value = originalJobPostingPrice.value;
        getJobPostPriceInfos
          .then((data) => {
            jobPostingPrice.value = data.jobPostingPrice;
            originalJobPostingPrice.value = data.jobPostingPrice;
            justJobPostingPrice.value = data.justJobPostingPrice;
            discountAndTaxInfosHtml.value = data.jobpostDiscountAndTaxInfoHtml;
          })
          .catch((error) => {
            console.error("Error fetching job post price info:", error);
          });
      }
    };

        // Custom validator for job_description
        const jobDescriptionValidator = (value) => {
            if (value.replace(/<(.|\n)*?>/g, '').trim().length === 0 && !value.includes("<img")) {
                return false;
            }
            return true;
        };

        const platformRoles = ref([]);

        const rules = computed(() => {
            return {
                job_type: {
                    required: helpers.withMessage('Please select job type', required),
                },
                job_title: {
                    required: helpers.withMessage('Please enter job title', required),
                    maxLength: helpers.withMessage('Job title must not be greater than 255 character', maxLength(255)),
                },
                job_location: {
                    required: helpers.withMessage('Please select job location', required),
                },
                job_category: {
                    required: helpers.withMessage('Please select job category', required),
                },
                min_rate: {
                    required: helpers.withMessage('Please enter the valid min rate', required),
                    // Checks if the input is numeric with optional decimals
                    numeric: helpers.withMessage(
                        'Invalid number format',
                        (value) => /^\d*(\.\d*)?$/.test(value)
                    ),
                    // Conditional validator for max digits before the decimal, with dynamic message
                    maxDigitsBeforeDecimal: helpers.withMessage(
                        () =>
                            form.rate_type === 'annual'
                                ? 'Only up to 7 digits are allowed before the decimal'
                                : 'Only up to 3 digits are allowed before the decimal',
                        (value) => {
                            const maxDigits = form.rate_type === 'annual' ? 7 : 3;
                            const regex = new RegExp(`^\\d{1,${maxDigits}}(\\.\\d*)?$`);
                            return regex.test(value);
                        }
                    ),
                    // Validator to ensure max 2 digits after the decimal
                    maxTwoDigitsAfterDecimal: helpers.withMessage(
                        'Only up to 2 decimal places are allowed',
                        (value) => /^\d*(\.\d{1,2})?$/.test(value)
                    ),
                    lessThanMax: helpers.withMessage('Min rate must be less than max rate', value => parseFloat(value) < parseFloat(form.max_rate))
                },
                max_rate: {
                    required: helpers.withMessage('Please enter the valid max rate', required),
                    // Checks if the input is numeric with optional decimals
                    numeric: helpers.withMessage(
                        'Invalid number format',
                        (value) => /^\d*(\.\d*)?$/.test(value)
                    ),
                    // Conditional validator for max digits before the decimal, with dynamic message
                    maxDigitsBeforeDecimal: helpers.withMessage(
                        () =>
                            form.rate_type === 'annual'
                                ? 'Only up to 7 digits are allowed before the decimal'
                                : 'Only up to 3 digits are allowed before the decimal',
                        (value) => {
                            const maxDigits = form.rate_type === 'annual' ? 7 : 3;
                            const regex = new RegExp(`^\\d{1,${maxDigits}}(\\.\\d*)?$`);
                            return regex.test(value);
                        }
                    ),
                    // Validator to ensure max 2 digits after the decimal
                    maxTwoDigitsAfterDecimal: helpers.withMessage(
                        'Only up to 2 decimal places are allowed',
                        (value) => /^\d*(\.\d{1,2})?$/.test(value)
                    ),
                    greaterThanMin: helpers.withMessage('Max rate must be greater than min rate', value => parseFloat(value) > parseFloat(form.min_rate))
                },
                job_description: {
                    required: helpers.withMessage('Please enter description', required),
                    customValidator: helpers.withMessage('Please enter description', jobDescriptionValidator),
                },
                questions: form.questionary === 'Yes' ? {
                    required: helpers.withMessage('At least one question is required', value => value.length > 0),
                    $each: helpers.forEach({
                        type: {
                            required: helpers.withMessage('Type must not be empty', value => value.trim() !== '')
                        },
                        question: {
                            required: helpers.withMessage('Question must not be empty', value => value.trim() !== ''),
                            maxLength: helpers.withMessage('Question must not be greater than 255 character', maxLength(255)),
                        },
                        options: {
                            required: helpers.withMessage('Options must not be empty for selected type', (value, parentVm) => {
                                const type = parentVm.type;
                                if (['checkbox', 'radio', 'select'].includes(type)) {
                                    return value && value.length > 0 && !value.some(option => option.trim() === '');
                                }
                                return true;
                            }),
                            maxLength: helpers.withMessage('Option must not be greater than 255 character', maxLength(255)),
                        }
                    })
                } : {}

            };
        });

        const v$ = useVuelidate(rules, form);
        const validateField = (fieldName) => {
            v$.value[fieldName].$touch();
            if (fieldName === 'max_rate' || fieldName === 'min_rate') {

                let value = event.target.value;
                const regex = /^\d{0,8}(\.\d{0,2})?$/;

                // Check if value matches the format
                if (!regex.test(value)) {
                    // If it doesn't, limit the input to a valid format
                    value = value.replace(/^(\d{0,8})(\.\d{0,2})?.*$/, '$1$2');
                }

                // Update the field's value with the validated format
                form[fieldName] = value;
            }
        };



        const payToPublish = async () => {
            $store.dispatch("setJobListingCreatePageData", extractJobFormData(form));
            $router.push({
                name: 'edit_payment_job_list',
                params: {
                    jobId: jobId.value
                }
            })
        }

        const checkQuestionary = async () => {

            if (form.questionary === 'Yes') {
                if (form.questions.length === 0) {
                    form.questions.push({ type: '', question: '', options: [] });
                }

            }
            v$.value.$validate()
        }
        const addQuestion = async () => {
            // Add a new question object to the questions array
            form.questions.push({ type: '', question: '', options: [] });
            const result = await v$.value.$validate()
            console.log("🚀 ~ addQuestion ~ result:", result)
        };

        const removeQuestion = (index) => {
            // Remove question at the specified index
            form.questions.splice(index, 1);
        };


        const addOption = (questionIndex) => {
            form.questions[questionIndex].options.push('');
        };

        const removeOption = (questionIndex, optionIndex) => {
            form.questions[questionIndex].options.splice(optionIndex, 1);
        };
        const handleQuestionChange = (index, value) => {
            form.questions[index].question = value;
        };
        const generateContentAi = () => {
            (async () => {
                try {

                    const response = await $store.dispatch("GET_JOB_POSTER_DESC_AI", {
                        params: {
                            ...form,
                        }
                    });
                    console.log("🚀 ~ response ssssssss:", response)
                    form.job_description = response.data.description;
                    form.short_description = response.data.shortDescription || null;
                } catch (error) {
                    console.log(error);
                    console.log("error submit!!");
                }
            })();
        }


        const showDialog = (event) => {
            event.preventDefault();
            dialogVisible.value = true;
        };

        const handleSelectionChange = (value) => {
            selectedOption.value = getCategories.value.find(option => option.value === value);
            console.log("🚀 ~ handleSelectionChange ~ selectedOption:", selectedOption)

        };

        const selectCategory = () => {
            if (!selectedCategories.value.includes(selectedOption.value)) {
                selectedCategories.value = selectedCategories.value.slice(0, 3);
                selectedCategories.value.push(selectedOption.value);
            }
            dialogVisible.value = false;
        };

        const setRateType = (type) => {
            form.rate_type = type;
            // validateField('rate'); // Trigger validation when rate type changes
        };

        const fetchSkills = async (query) => {
            if (!query) {
                return;
            }
            loading.value = true;
            try {
                // Dispatch an action to fetch data from your API using Vuex store
                const response = await $store.dispatch("GET_SKILLS", {
                    'search': query,
                    'id': jobId.value
                });
                console.log("🚀 ~ fetchSkills ~ response:", response)
                // Assuming response.data contains the options you want to display
                searchQueryoptions.value = response.data
                    .map(skill => ({ label: skill.name, value: skill.id }));
            } catch (error) {
                console.error('Error fetching options:', error);
            } finally {
                loading.value = false;
            }
        };

        // Watch for changes in selectedCombineSkillOptions
        watch(selectedCombineSkillOptions, (newValue) => {
            // Update job_skills in the form object
            form.job_skills = newValue.map(option => option);
        });

        // Function to remove selected skill
        const removeSelectedSkill = (skill) => {
            const index1 = searchSkillOptions.value.findIndex(item => item.value === skill.value);
            if (index1 !== -1) {
                searchSkillOptions.value.splice(index1, 1);
            }

            const index2 = selectedPopularSkills.value.findIndex(item => item.value === skill.value);
            if (index2 !== -1) {
                selectedPopularSkills.value.splice(index2, 1);
            }
        };
        const isSubmitDisabled = computed(() => {
            return Object.values(form).some(value => value === '') || v$.value.$pending || v$.value.$error || v$.value.$invalid;
        });

        const setAddressData = (addressData) => {
            // if addressData is a string, parse it to JSON
            if (typeof addressData === 'string') {
                addressData = JSON.parse(addressData);
            }
            form.job_location = addressData;
            jobLocationText.value = addressData.formatted_address;

            addressComponent.value += 1;
        };

        const updateAddressData = (addressData) => {
            // if addressData is a string, parse it to JSON
            if (typeof addressData === 'string') {
                addressData = JSON.parse(addressData);
            }
            form.job_location = addressData;
        };

        const setAddress = () => {
            form.job_location = '';
            v$.value.$validate()
        };

        const updateJobPost = async (type) => {
            const result = await v$.value.$validate()

            if (!result) {
                alert('The form has errors')
                return
            } else {
                console.log("🚀 ~ updateJobPost ~ result:", form)
                form.save_as = type;


                try {
                    await ElMessageBox.confirm(
                        `Are you sure you want to update this job?`,
                        "Update Job",
                        {
                            confirmButtonText: "Update",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--primary",
                            cancelButtonClass: "el-button--grey",
                            showClose: false,
                        }
                    );

                    await (async () => {
                        try {
                            const response = await $store.dispatch("UPDATE_JOB_POST", { jobId: jobId.value, params: form });
                            console.log("🚀 ~ await ~ response:", response)

                            if (response.data.success) {
                                ElMessage({
                                    type: "success",
                                    message: response.data.message,
                                });
                                await $store.dispatch("SET_CURRENT_USER_DATA", {
                                    with:
                                        "settings,billingInfo,schedule,bankVerification,address,push_notifications,config.hours_before_shift_lock",
                                });
                            } else {
                                ElMessage({
                                    type: "info",
                                    message: response.data.message,
                                });
                            }

                            $router.push({
                                name: "job_poster",
                            });

                        } catch (error) {
                            if (error.message) {
                                ElMessage({
                                    type: "error",
                                    message: error.message,
                                });
                            }
                        }
                    })();
                } catch (error) {
                    console.log(error);
                }
            }

        };

        const goBack = () => {
            $router.push({
                name: 'job_poster'
            })
        };

        onMounted(() => {
            setPageClassGlobal('job_poster_edit_job_lisitng');
            form.job_category = selectedCategories[0].value;

            form.job_location.update(
                form.job_location
            );

        });

        const initialFetchJobData = async () => {
            return new Promise((resolve) => {
                let structuredSkills = [];
                $store.dispatch("FETECH_JOB_DETAIL_ID", jobId.value)
                    .then((response) => {
                        let jobData = response.data.data;
                        console.log("🚀 ~ .then ~ jobFetchResult:", jobData)
                        form.job_type = jobData.jobType;
                        form.job_title = jobData.jobTitle;
                        setAddressData(jobData.jobLocation);
                        form.save_as = jobData.status;
                        jobPostStatus.value = jobData.status;

                        // Check if job_skills exists in jobData and is an array before adding it to selectedCombineSkillOptions
                        if (jobData.jobSkills && Array.isArray(jobData.jobSkills)) {

                            jobData.jobSkills.forEach(skill => {
                                structuredSkills = { label: skill.name, value: skill.id };

                                // Push to selectedPopularSkills
                                selectedPopularSkills.value.push(structuredSkills);

                            });

                        }
                        form.min_rate = jobData.minRate;
                        form.max_rate = jobData.maxRate;
                        form.rate_type = jobData.rateType;
                        form.bonus = jobData.bonus;
                        form.job_description = jobData.jobDescription;
                        form.short_description = jobData.shortDescription;
                        const categoryObject = getCategories.value.find(category => category.value === jobData.jobCategory);
                        if (!selectedCategories.value.includes(categoryObject)) {
                            selectedCategories.value = selectedCategories.value.slice(0, 3);
                            selectedCategories.value.push(categoryObject);
                        }
                        form.job_category = categoryObject.value
                        if (jobData.questions.length > 0) {
                            form.questionary = 'Yes';
                        } else {
                            form.questionary = 'No'
                        }

                        form.questions = jobData.questions ? jobData.questions : [];

                        if (form.questionary === 'Yes' && form.questions.length === 0) {
                            addQuestion(); // Add default question item
                        }
                        form.platform_role_id = jobData.platformRoleId;
                        platformRoleId.value = jobData.platformRoleId;
                        form.hide_salary = jobData.hideSalary;
                        console.log({ form })
                        resolve(response);
                    });
            });
        };

        const isSelected = (item) => {
            const result = selectedPopularSkills.value.some(selectedItem => selectedItem.value === item.value);
            console.log("🚀 ~ isSelected ~ result:", result)
            return result;
        };

        onBeforeMount(async () => {
            return new Promise((resolve) => {
                $store
                    .dispatch("GET_JOB_POSTER_LISTINGS")
                    .then((response) => {
                        console.log("🚀 ~ .then ~ response:", response)
                        initialFetchJobData();
                        let FetchResult = response.data;
                        console.log("🚀 ~ .then ~ FetchResult:", FetchResult)
                        FetchResult.popularSkills.forEach(skill => {
                            popularSkillsOptions.value.push({ label: skill.name, value: skill.id });
                        });
                        console.log("🚀 ~ .then ~ AAA111popularSkillsOptions:", popularSkillsOptions)

                        FetchResult.type.forEach(type => {
                            jobTypeOptions.value.push({ label: type.title, value: type.id });
                        });

                        FetchResult.location.forEach(location => {
                            jobLocations.value.push({ label: location.name, value: location.id });
                        });

                        FetchResult.category.forEach(item => {
                            getCategories.value.push({ label: item.title, value: item.id });
                        });

                        FetchResult.platformRoles.forEach(item => {
                            platformRoles.value.push({ label: item.name, value: item.id, is_free_job: item.isFreeJob });
                        });

                        selectedCategories.value = getCategories.value.slice(0, 3);
                        form.job_type = jobTypeOptions.value[0].value;
                        form.job_category = getCategories.value[0].value;
                        form.platform_role_id = platformRoles.value[0].value;
                        console.log("🚀 ~ .then ~ getCategories[0]:", getCategories.value[0].value)
                        resolve(response);
                    });
            });
        });

        const isLocumateAndSpecialRole = computed(() => {
            const selectedPlatformRole = platformRoles.value.find(role => role.value === form.platform_role_id);
            const isSelectedPlatformRoleIsFreeJob = selectedPlatformRole ? selectedPlatformRole.is_free_job : false;
            return brandName === "LOCUMATE" && isSelectedPlatformRoleIsFreeJob;
        });

        // Add this in your setup() function, with other reactive properties
        const filteredPlatformRoles = computed(() => {

            if (brandName === "LOCUMATE") {
                if (!form.platform_role_id) return platformRoles.value;

                // Find the selected role
                const selectedRole = platformRoles.value.find(
                    role => role.value === form.platform_role_id
                );

                if (!selectedRole) return platformRoles.value;

                // Filter based on is_free_job status
                return platformRoles.value.filter(
                    role => role.is_free_job === selectedRole.is_free_job
                );
            } else {
                return platformRoles.value;
            }

        });


        function extractJobFormData(form) {
            return {
                job_type: form.job_type,
                job_title: form.job_title,
                job_location: form.job_location && typeof form.job_location === "object"
                    ? {
                        administrative_area_level_1: form.job_location.administrative_area_level_1 || "",
                        administrative_area_level_2: form.job_location.administrative_area_level_2 || "",
                        country: form.job_location.country || "",
                        formatted_address: form.job_location.formatted_address || "",
                        latitude: form.job_location.latitude || null,
                        longitude: form.job_location.longitude || null,
                        locality: form.job_location.locality || "",
                        postal_code: form.job_location.postal_code || "",
                    }
                    : null,

                job_category: form.job_category,
                job_skills: form.job_skills, // clone to avoid reactivity
                min_rate: form.min_rate,
                max_rate: form.max_rate,
                rate_type: form.rate_type,
                bonus: form.bonus,
                job_description: form.job_description,
                short_description: form.short_description,
                save_as: form.save_as,
                // questionary: form.questionary,
                // questions: form.questions.map((q) => ({
                //     type: q.type,
                //     question: q.question,
                //     options: Array.isArray(q.options) ? [...q.options] : [],
                // })),
                questionary: form.questionary,
                questions: form.questions.map((q) => ({
                    type: q.type,
                    question: q.question,
                    options: [...q.options], // ensures plain array copy
                })),
                platform_role_id: form.platform_role_id,
                hide_salary: form.hide_salary,
            };
        }

        return {
            goBack,
            updateJobPost,
            isSubmitDisabled,
            rules,
            form,
            jobTypeOptions,
            validateField,
            v$,
            jobLocations,
            getCategories,
            selectedCategories,
            dialogVisible,
            showDialog,
            selectCategory,
            handleSelectionChange,
            searchSkillOptions,
            searchQueryoptions,
            loading,
            fetchSkills,
            selectedPopularSkills,
            popularSkillsOptions,
            selectedCombineSkillOptions,
            removeSelectedSkill,
            setRateType,
            generateContentAi,
            jobId,
            isSelected,
            addQuestion,
            removeQuestion,
            checkQuestionary,
            handleQuestionChange,
            addOption,
            removeOption,
            payToPublish,
            setAddressData,
            isAustralia,
            countryArray,
            addressComponent,
            jobLocationText,
            updateAddressData,
            setAddress,
            platformRoles,
            freeJobPosts,
            usedFreeJobListings,
            jobPostingPrice,
            originalJobPostingPrice,
            justJobPostingPrice,
            discountAndTaxInfosHtml,
            isAus,
            Amount,
            brandName,
            isLocumateAndSpecialRole,
            platformRoleId,
            filteredPlatformRoles,
            totalNumberOfFreeJobListings,
            jobPostStatus,
            subscription,
            updateJobPostingPrice,
            clearCouponCode,
            extractJobFormData
        }
    },
}
</script>
